import { Eye, Save, Settings, Trash2 } from "lucide-react";
import CarnetNoteIcon from "./IconComponent/CarnetNoteIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_NOTES_TOOLTIPS } from "../constants/menuTooltips";

const ICON_COLOR = "#39210d";

export default function MenuNotesMiddle({
  visible = false,
  isEditing = false,
  hasNote = false,
  canSave = false,
  settingsActive = false,
  onRead = () => {},
  onEdit = () => {},
  onSave = () => {},
  onDelete = () => {},
  onSettingsClick = () => {},
}) {
  if (!visible) return <div className="menuMilieuContainer" />;

  const canRead = hasNote && isEditing;
  const canEdit = hasNote && !isEditing;
  const canDelete = hasNote;
  const readActive = hasNote && !isEditing;
  const editActive = hasNote && isEditing;

  return (
    <div className="menuMilieuContainer menuNotesMiddle">
      <MenuIconTooltip
        tooltip={
          canRead
            ? MENU_NOTES_TOOLTIPS.read
            : readActive
              ? MENU_NOTES_TOOLTIPS.readActive
              : MENU_NOTES_TOOLTIPS.readDisabled
        }
        placement="left"
        portal
        className={readActive ? "icon active" : "icon"}
      >
        <Eye
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onClick={canRead ? onRead : undefined}
          aria-label="Mode lecture"
          aria-disabled={!canRead && !readActive}
          style={{ cursor: canRead || readActive ? "pointer" : "default" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={
          canEdit
            ? MENU_NOTES_TOOLTIPS.edit
            : editActive
              ? MENU_NOTES_TOOLTIPS.editActive
              : MENU_NOTES_TOOLTIPS.editDisabled
        }
        placement="left"
        portal
        className={editActive ? "icon active" : "icon"}
      >
        <CarnetNoteIcon
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onClick={canEdit ? onEdit : undefined}
          aria-label="Mode modification"
          aria-disabled={!canEdit && !editActive}
          style={{ cursor: canEdit || editActive ? "pointer" : "default" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_NOTES_TOOLTIPS.save}
        placement="left"
        portal
        className={canSave ? "icon active" : "icon"}
      >
        <Save
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onMouseDown={(event) => {
            // Évite de voler le focus du champ en cours d'édition.
            if (canSave) event.preventDefault();
          }}
          onClick={canSave ? onSave : undefined}
          aria-label="Enregistrer la note"
          aria-disabled={!canSave}
          style={{ cursor: canSave ? "pointer" : "default" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={
          canDelete ? MENU_NOTES_TOOLTIPS.delete : MENU_NOTES_TOOLTIPS.deleteDisabled
        }
        placement="left"
        portal
        className="icon"
      >
        <Trash2
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onClick={canDelete ? onDelete : undefined}
          aria-label="Supprimer la note"
          aria-disabled={!canDelete}
          style={{ cursor: canDelete ? "pointer" : "default" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_NOTES_TOOLTIPS.settings}
        placement="left"
        portal
        className={settingsActive ? "icon active" : "icon"}
      >
        <Settings
          size={50}
          color={ICON_COLOR}
          strokeWidth={1}
          onClick={onSettingsClick}
          aria-label="Paramètres du carnet de notes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
